import { timerActions } from "../../../store/timerSlice"
import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"

export const GetDependencyDataMutation = <T>(
    locationId:string,
    callbacks?: Callbacks<T>,
) => {
    const { onError, onLoading, onSuccess } = useCallBack<any>(callbacks)

    const { getRequest, postRequest } = useHttpRequest({})
    return async (dispatch: any) => {
        const getUsers = async () => {
            try {
                const response = await getRequest(`${UrlConstant.UserDependency}/${UrlConstant?.GetAllActiveRecord}?locationId=${locationId}`)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        const getTaskCodes = async () => {
            try {
                const response = await getRequest(`${UrlConstant.UTBMSCode}/${UrlConstant?.GetAllActiveRecord}?type=3`)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        const getExpenseCodes = async () => {
            try {
                const response = await getRequest(`${UrlConstant.UTBMSCode}/${UrlConstant?.GetAllActiveRecord}?type=2`)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        const getTimeEntryCategories = async () => {
            try {
                const response = await getRequest(`${UrlConstant.ActivityCategory}/${UrlConstant?.GetAllActiveRecord}`)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        const getExpenseCategories = async () => {
            try {
                const response = await getRequest(`${UrlConstant.ExpenseCategory}/${UrlConstant?.GetAllActiveRecord}`)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        const getUtbmsGroups = async () => {
            try {
                const response = await getRequest(`${UrlConstant.UTBMSDefaultGroup}/${UrlConstant?.GetAllActiveRecords}`)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        const getTaxes = async () => {
            try {
                const response = await getRequest(`${UrlConstant.Tax}/${UrlConstant?.GetAllActiveRecord}`)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        try {
            
            const users = await getUsers()
            const taskCodes = await getTaskCodes()
            const timeEntryCategories = await getTimeEntryCategories()
            const expenseCodes = await getExpenseCodes()
            const expenseCategories = await getExpenseCategories()
            const isEnableUtbms = await getUtbmsGroups()
            const taxes = await getTaxes()
            dispatch(timerActions.getDependencyData({ users, taskCodes, timeEntryCategories, expenseCategories, isEnableUtbms,taxes, expenseCodes}))

        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
// export const GetDependencyDataMutation = <T>(
//     locationId:string,
//     callbacks?: Callbacks<T>,
// ) => {
//     const { onError, onLoading } = useCallBack<T>(callbacks)
//     const { getRequest } = useHttpRequest({})

//     return async (dispatch: any) => {
//         onLoading(true)
//         const [
//             getMatters,
//             getUsers,
//             getTaskCodes,
//             getExpenseCodes,
//             getTimeEntryCategories,
//             getExpenseCategories,
//             getUtbmsGroups,
//             getTaxes,
//         ] = await useDependency([
//             getRequest(`${UrlConstant.MatterDependency}/${UrlConstant.GetAllActiveRecord}`),
//             getRequest(`${UrlConstant.UserDependency}/${UrlConstant.GetAllActiveRecord}?locationId=${locationId}`),
//             getRequest(`${UrlConstant.UTBMSCode}/${UrlConstant.GetAllActiveRecord}?type=3`),
//             getRequest(`${UrlConstant.UTBMSCode}/${UrlConstant.GetAllActiveRecord}?type=2`),
//             getRequest(`${UrlConstant.ActivityCategory}/${UrlConstant.GetAllActiveRecord}`),
//             getRequest(`${UrlConstant.ExpenseCategory}/${UrlConstant.GetAllActiveRecord}`),
//             getRequest(`${UrlConstant.UTBMSDefaultGroup}/${UrlConstant.GetAllActiveRecords}`),
//             getRequest(`${UrlConstant.Tax}/${UrlConstant.GetAllActiveRecord}`),
//         ])
//         try {
            // const matters = getMatters.data ? getMatters.data : []
            // const users = getUsers.data ? getUsers.data : []
            // const taskCodes = getTaskCodes.data ? getTaskCodes.data : []
            // const timeEntryCategories = getTimeEntryCategories.data
            //     ? getTimeEntryCategories.data
            //     : []
            // const expenseCodes = getExpenseCodes.data ? getExpenseCodes.data : []
            // const expenseCategories = getExpenseCategories.data ? getExpenseCategories.data : []
            // const isEnableUtbms = getUtbmsGroups.data ? getUtbmsGroups.data : []
            // const taxes = getTaxes.data ? getTaxes.data : []

//             dispatch(
//                 timerActions.getDependencyData({
//                     matters,
//                     users,
//                     taskCodes,
//                     timeEntryCategories,
//                     isEnableUtbms,
//                     expenseCodes,
//                     expenseCategories,
//                     taxes,
//                 })
//             )
//         } catch (error) {
//             onError(error as Error)
//         } finally {
//             onLoading(false)
//         }
//     }
// }
